export enum bahai_type {
  Region = 200630000,
  Cluster = 200630001,
  Locality = 200630002,
  Other = 200630003,
  ClusterGroup = 200630004,
  SubRegion = 200630005,
}
